import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer } from 'react-sortable-hoc';
import { getLocalStorage } from '@zola-helpers/client';

// virtual events
import AddAVirtualEventButton from 'components/manage/common/AddAVirtualEventButton';

// actions
import { showModal } from 'actions/ModalActions';
import { getEventsV2, editEvent } from 'actions/website/entities/EventActions';
import {
  moveEntity,
  resetEntities,
  addEntity,
  deleteEntityV2,
} from 'actions/website/EntityActions';
import { deleteEvent } from 'actions/EventActions';
import { togglePage } from 'actions/website/PageActions';
import * as ModalActions from 'actions/ModalActions';

// components
import { CARD_TYPES } from 'cards/constants/CardTypes';
import EventDetails from './EventDetails';
import EditPageForm from '../EditPageCommon/EditPageFormContainer';
import EditPageHeader from '../EditPageCommon/EditPageHeader';
import EditPageAddEntity from '../EditPageCommon/EditPageAddEntity';
import PaperPreviewCrossSellModule from '../../PaperPreviewCrossSellModule';

import { localStorageKey } from '../../WalkthroughTour/StepCollections/VirtualEventsOnboardingEditPage';

class Events extends Component {
  constructor(props) {
    super(props);

    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    const { getEventEntities } = this.props;
    getEventEntities();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  onEdit(event) {
    const { onEditVirtualEvent, onEditEvent } = this.props;
    if (event.virtual_meeting) {
      // open edit virtual event modal
      onEditVirtualEvent(event);
    } else {
      // open normal edit event modal
      onEditEvent(event);
    }
  }

  render() {
    const {
      eventEntities,
      orderedIds,
      openModal,
      onDelete,
      page,
      themeKey,
      onPageToggle,
    } = this.props;
    const pageType = page && page.type;

    const isVirtualEventTourDisabled = getLocalStorage(localStorageKey) === 'true';
    return (
      <div>
        {themeKey && (
          <EditPageHeader
            onAdd={openModal}
            entityName="Event"
            page={page}
            themeKey={themeKey}
            onPageToggle={onPageToggle}
          />
        )}
        <>
          <EditPageForm page={page} />
          <EditPageAddEntity
            entityName="Event"
            onAddText="Add An Event"
            pageType={pageType}
            orderedIds={orderedIds}
            entities={eventEntities}
            onAdd={openModal}
            onEdit={this.onEdit}
            onDelete={onDelete} // TODO: re-visit why event deletion removed
            entityDetail={EventDetails}
            isVirtualEventTourDisabled={isVirtualEventTourDisabled}
          />
        </>
        {!isVirtualEventTourDisabled && (
          <div
            className="events-virtual edit-page__add-entity-section"
            id="edit-page__add-entity-section__virtual-events"
          >
            <h4 className="entities-list-title--virtual-event">Your Virtual Events</h4>
            <div className="edit-page__intro">
              Host a Zoom shower, ceremony, or wedding right on your site.
            </div>
            <AddAVirtualEventButton className="add-entity-btns-section" />
          </div>
        )}
        <PaperPreviewCrossSellModule
          themeKey={themeKey}
          trackingParams={{
            cta_id: `single_sample_website_edit_schedule`,
            location: 'WEBSITE',
            section: `WEBSITE_EDIT_SCHEDULE`,
          }}
          backgroundColor="pink"
          hedPrePend="Add Your Event Details to"
          cardType={CARD_TYPES.invitation}
        />
      </div>
    );
  }
}

Events.propTypes = {
  eventEntities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getEventEntities: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEditEvent: PropTypes.func.isRequired,
  onEditVirtualEvent: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
};

const mapStateToProps = state => ({
  eventEntities: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.EVENT],
  themeKey: state.wedding.theme.key,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  openModal: () => {
    dispatch(addEntity());
    dispatch(
      showModal('EVENT_FORM', { websiteEvent: true, formIdentifier: 'eventForm' }, { size: 'md' })
    );
  },
  openDeleteEventModal: (rsvpCount, eventUuid) => {
    dispatch(
      ModalActions.showModal(
        'DELETE_RSVP_EVENT',
        {
          rsvpCount,
          eventUuid,
        },
        { size: 'md' }
      )
    );
  },
  getEventEntities: () => dispatch(getEventsV2()),
  onEditVirtualEvent: event => {
    dispatch(
      showModal(
        'VIRTUAL_EVENT_FORM',
        {
          websiteEvent: true,
          initialValues: event,
        },
        { size: 'md' }
      )
    );
  },
  onEditEvent: event => {
    dispatch(editEvent(event));
    dispatch(
      showModal('EVENT_FORM', { websiteEvent: true, formIdentifier: 'eventForm' }, { size: 'md' })
    );
  },
  onDelete: event => {
    // if an event already has RSVPs, open a modal to redirect users to Manage RSVP page
    if (event.num_guests_attending || event.num_guests_declined) {
      dispatch(
        ModalActions.showModal(
          'DELETE_RSVP_EVENT',
          {
            rsvpCount: event.num_guests_attending + event.num_guests_declined,
            eventUuid: event.uuid,
          },
          { size: 'md' }
        )
      );
    } else {
      dispatch(deleteEntityV2(event));
    }
  },
  onDeleteRSVPEvent: eventId => {
    dispatch(deleteEvent(eventId));
  },
  unloadEntities: () => dispatch(resetEntities()),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
});

const SortableEvents = SortableContainer(Events);

const EventsContainer = connect(mapStateToProps, mapDispatchToProps)(SortableEvents);

export default EventsContainer;
